var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-select", {
    ref: "customerSelect",
    attrs: {
      value: _vm.customerSearchWord,
      "use-input": "",
      "hide-selected": "",
      "fill-input": "",
      "input-debounce": "500",
      label: _vm.$t("customer"),
      options: _vm.customers,
      "option-label": "Account_Name",
      loading: _vm.loading,
      error: _vm.error,
      "error-message": _vm.$t("error.customer")
    },
    on: { input: _vm.selectCustomer, filter: _vm.filterCustomers },
    scopedSlots: _vm._u([
      {
        key: "no-option",
        fn: function(scope) {
          return [
            _c("div", { staticClass: "q-pa-md" }, [
              _vm._v(_vm._s(_vm.$t("noResults")))
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }